import { render } from "./EditJobTagsModal.vue?vue&type=template&id=b26175ca&scoped=true"
import script from "./EditJobTagsModal.vue?vue&type=script&lang=js"
export * from "./EditJobTagsModal.vue?vue&type=script&lang=js"

import "./EditJobTagsModal.vue?vue&type=style&index=0&id=b26175ca&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26175ca"]])

export default __exports__